<div class="dialog">
  <div class="profile">
    <mat-icon id="close" style="width: 18px;height: 18px;" svgIcon="cross" (click)="closeModal()"></mat-icon>
    <div class="section-1"  *ngIf="!change" style="max-width: 157px;margin: auto;">
      <div class="picture">
        <div class="loading" *ngIf="loader">
          <div [ngClass]="{loader: loader}"></div>
        </div>
        <img id="pPic" src="{{profile_image}}" alt="Picture">
      </div>
      <div class="gallery">
        <input id="image_input"  #imageInput (change)="uploadExplorImage($event)" class="hidden" accept="image/*" type="file" />
        <button (click)="openExplorer('image')"  mat-button class="cent">
          <!-- <mat-icon svgIcon="gallery"></mat-icon> -->
        </button>
      </div>
    </div>
    <div id="backDrop">
      <form [formGroup]="profileForm" (ngSubmit)="saveUserdetail(profileForm)">
        <ngx-loading [show]="loader1" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.6)'}"></ngx-loading>
        <div class="section-2" *ngIf="!change">
          <div class="row">
            <div id="name" class="col-md-6">
              <span class="spclr">First Name</span>
              <div id="inputs">
                <input class="form-control input-sm" type="text" formControlName="fname" placeholder="Firstname">
                <mat-error *ngIf="profileForm.controls['fname'].hasError('required')"> First name is Required! </mat-error>
                <mat-error *ngIf="profileForm.controls['fname'].hasError('pattern')"> First name is invalid! </mat-error>
                <mat-error *ngIf="profileForm.controls['fname'].hasError('maxlength')"> First name no more than 45 characters! </mat-error>
                <mat-error *ngIf="profileForm.controls['fname'].hasError('minlength')"> First name minimum 2 characters</mat-error>

              </div>
            </div>
            <div id="name" class="col-md-6">
              <span class="spclr">Last Name</span>
              <div id="inputs">
                <input class="form-control input-sm" type="text" formControlName="lname" placeholder="Lastname">
                <mat-error *ngIf="profileForm.controls['lname'].hasError('required')"> Last name is Required! </mat-error>
                <mat-error *ngIf="profileForm.controls['lname'].hasError('pattern')"> Last name is invalid! </mat-error>
                <mat-error *ngIf="profileForm.controls['lname'].hasError('maxlength')"> Last name no more than 45 characters! </mat-error>
                <mat-error *ngIf="profileForm.controls['lname'].hasError('minlength')"> Last name minimum 2 characters</mat-error>

              </div>
            </div>
          </div>
          <div id="email">
            <span class="spclr">E-Mail</span>
            <input class="form-control input-sm" type="email" formControlName="email" placeholder="e-mail">
          </div>
          <div id="contact">
            <span class="spclr">Contact</span>
            <!-- <input class="form-control input-sm" type="number" formControlName="contact" placeholder="+99 999 999 9999"> -->
            <div class="form-control" style="display: table-footer-group;">
              <ngx-intl-tel-input [onlyCountries]="preferredCountries"
                [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.All]" [selectFirstCountry]="true" [maxLength]="15"
                [phoneValidation]="true" [separateDialCode]="true" [numberFormat]="PhoneNumberFormat.National"
                formControlName="contact">
              </ngx-intl-tel-input>
              </div>
          </div>
          <div class="row">
            <div id="city" class="col-md-6">
              <span class="spclr">City</span>
              <mat-select class="form-control" formControlName="city">
                <mat-option *ngFor="let city of city_list" class="ddList" value="{{city.place_name}}">{{city.place_name}}
                </mat-option>
              </mat-select>
            </div>
            <div id="language" class="col-md-6">
              <span class="spclr">Language</span>
              <mat-select class="form-control" formControlName="language">
                <mat-option *ngFor="let lang of language_list" class="ddList" value="{{lang.language_code}}">{{lang.name}}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="right-btn">
            <div class="free-space"></div>
            <div class="cent">
              <button [disabled]="profileForm.invalid || loader" mat-button class="bluebutton1" type="submit">
                <span class="fnt-up" *ngIf="!loader && !loader1">
                  Save
                </span>
                <span class="fnt-up" *ngIf="loader || loader1">
                  Saving...
                </span>
              </button>
              <button mat-button class="orange1" (click)="changePass()">
                <span class="fnt-up">
                  Change Password
                </span>
              </button>
            </div>

          </div>
          <div>
            <input type="hidden" formControlName="image" />
          </div>
        </div>
      </form>
      <div *ngIf="change">
      <form [formGroup]="changePasswordForm" autocomplete="off">
        <div class="section-3">
          <div class="mb-2"><h4>Change password</h4></div>
          <div id="pass">
            <span class="spclr mb-1">Old Password</span>
           <div class="position-relative">
          <input  class="form-control input-sm" (paste)="onPaste($event)" autocomplete="new-password"  [type]="oldPasswordType" formControlName="oldPassword"
          placeholder="Old Password">
          <button class="isShow-btn" (click)="isShow('oldPassword')">
            <mat-icon *ngIf="oldPasswordType == 'password'"  _ngcontent-ums-admin-c44="" role="img" class="mat-icon notranslate eye-icon material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility_off</mat-icon>
            <mat-icon *ngIf="oldPasswordType == 'text'" _ngcontent-ums-admin-c44="" role="img" class="mat-icon notranslate eye-icon material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility</mat-icon>
          </button>
         </div>
          </div>
         <mat-error class="help-block" *ngIf="changePasswordForm.controls['oldPassword'].hasError('required') && changePasswordForm.get('oldPassword').touched">
          Current password is required.
        </mat-error>
          <div id="pass">
            <span class="spclr mb-1">New Password</span>
           <div class="position-relative">
            <input class="form-control input-sm" (paste)="onPaste($event)" [type]="passwordType"  formControlName="password"
            placeholder="New Password">
            <button class="isShow-btn" (click)="isShow('password')">
             <mat-icon *ngIf="passwordType == 'password'"  _ngcontent-ums-admin-c44="" role="img" class="mat-icon notranslate eye-icon material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility_off</mat-icon>
             <mat-icon *ngIf="passwordType == 'text'" _ngcontent-ums-admin-c44="" role="img" class="mat-icon notranslate eye-icon material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility</mat-icon>
           </button>
           </div>
          </div>
          <div>
             <mat-error  *ngIf="changePasswordForm.controls['password'].hasError('required') && changePasswordForm.get('password').touched">
              New password is required.
         </mat-error>
          </div>
          <div>
            <mat-error *ngIf="changePasswordForm.controls['password'].hasError('minlength'); else hasNumber">
             New password may not be less than 8 characters.
           </mat-error>
          <ng-template #hasNumber>
            <mat-error *ngIf="changePasswordForm.controls['password'].hasError('hasNumber'); else hasCapitalCase">
              New password should contain at least 1 numeric character.
            </mat-error>
          </ng-template>
        <ng-template #hasCapitalCase>
            <mat-error *ngIf="changePasswordForm.controls['password'].hasError('hasCapitalCase'); else hasSmallCase">
              New password should contain at least 1 uppercase character.
            </mat-error>
          </ng-template>
          <ng-template #hasSmallCase>
            <mat-error *ngIf="changePasswordForm.controls['password'].hasError('hasSmallCase'); else hasSpecialCharacters">
              New password should contain at least 1 lowercase character.
            </mat-error>
          </ng-template>
          <ng-template #hasSpecialCharacters>
            <mat-error *ngIf="changePasswordForm.controls['password'].hasError('hasSpecialCharacters')">
              New password should contain at least 1 special character.
            </mat-error>
              <mat-error *ngIf="changePasswordForm.controls['password'].hasError('maxlength');">
               New password may not be longer than 20 characters.
           </mat-error>
          </ng-template>
          </div>
          <div id="pass">
            <span class="spclr mb-1">Confirm Password</span>

              <div class="position-relative">
                <input class="form-control input-sm" #cnfrmPass [type]="passwordCnfrmType" (paste)="onPaste($event)" formControlName="confirmPassword"
                placeholder="Confirm Password" required>
                <button class="isShow-btn" (click)="isShow('cnfirmPassword')">
                 <mat-icon *ngIf="passwordCnfrmType == 'password'"  _ngcontent-ums-admin-c44="" role="img" class="mat-icon notranslate eye-icon material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility_off</mat-icon>
                 <mat-icon *ngIf="passwordCnfrmType == 'text'" _ngcontent-ums-admin-c44="" role="img" class="mat-icon notranslate eye-icon material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility</mat-icon>
               </button>
               </div>
          </div>

          <div class="error-wrapper">
            <mat-error *ngIf="changePasswordForm.controls['confirmPassword'].hasError('required') && changePasswordForm.get('confirmPassword').touched">
              Confirm password is required.
         </mat-error>
            <mat-error *ngIf="cnfrmPass.value.length > 0 && changePasswordForm.controls['confirmPassword'].hasError('NoPassswordMatch')"><span>   Password do not match!</span></mat-error>
          </div>
          <div class="right-btn mt-2">
            <button mat-button type="button" class="bluebutton1" [disabled]="changePasswordForm.invalid" (click)="changePassword()">
              <span class="fnt-up">
                Update
              </span>
            </button>
          </div>
        </div>

      </form>

    </div>
    </div>
  </div>
</div>
